import Model from "./Model";
import RefrigerantTypesQuery from "../queries/RefrigerantTypes";

export default class RefrigerantTypes extends Model {

    static getAllRefrigerantTypes = async () => {
        const res = await this.runQueryNetworkOnly(RefrigerantTypesQuery);
        console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@ RefrigerantTypes.runQuery [COMPLETE]`);
        return res.data.refrigerantTypes;
    }

}
